module.exports = __webpack_public_path__ + "media/svg/dm-8d613ebe.svg";